var map = {
	"./companyprofile/aptitude_mb": [
		"G2hE",
		6
	],
	"./companyprofile/aptitude_mb.vue": [
		"G2hE",
		6
	],
	"./companyprofile/culture_mb": [
		"DSWC",
		5
	],
	"./companyprofile/culture_mb.vue": [
		"DSWC",
		5
	],
	"./companyprofile/honor_mb": [
		"vAea",
		7
	],
	"./companyprofile/honor_mb.vue": [
		"vAea",
		7
	],
	"./companyprofile/introduction_mb": [
		"xoYL",
		21
	],
	"./companyprofile/introduction_mb.vue": [
		"xoYL",
		21
	],
	"./companyprofile/organization_mb": [
		"pCrb",
		9
	],
	"./companyprofile/organization_mb.vue": [
		"pCrb",
		9
	],
	"./dynamicstate/industry_mb": [
		"Aqs5",
		8
	],
	"./dynamicstate/industry_mb.vue": [
		"Aqs5",
		8
	],
	"./dynamicstate/newdetail_mb": [
		"XHAw",
		47
	],
	"./dynamicstate/newdetail_mb.vue": [
		"XHAw",
		47
	],
	"./dynamicstate/news1": [
		"P2UZ",
		10
	],
	"./dynamicstate/news1.vue": [
		"P2UZ",
		10
	],
	"./dynamicstate/news_mb": [
		"Rym3",
		36
	],
	"./dynamicstate/news_mb.vue": [
		"Rym3",
		36
	],
	"./feedback/questionnaire_mb": [
		"2Kby",
		0,
		23
	],
	"./feedback/questionnaire_mb.vue": [
		"2Kby",
		0,
		23
	],
	"./index_mb": [
		"+i3Q",
		16
	],
	"./index_mb.vue": [
		"+i3Q",
		16
	],
	"./mb": [
		"7Mbv",
		28
	],
	"./mb.vue": [
		"7Mbv",
		28
	],
	"./ours/forgetdetail_mb": [
		"iaz8",
		34
	],
	"./ours/forgetdetail_mb.vue": [
		"iaz8",
		34
	],
	"./ours/recruitment_mb": [
		"tySs",
		27
	],
	"./ours/recruitment_mb.vue": [
		"tySs",
		27
	],
	"./relation_mb": [
		"VLdN",
		43
	],
	"./relation_mb.vue": [
		"VLdN",
		43
	],
	"./specialtyinstruction/jindiananlidetail_mb": [
		"2KzM",
		48
	],
	"./specialtyinstruction/jindiananlidetail_mb.vue": [
		"2KzM",
		48
	],
	"./specialtyinstruction/project_mb": [
		"zo/H",
		12
	],
	"./specialtyinstruction/project_mb.vue": [
		"zo/H",
		12
	],
	"./specialtyinstruction/projectdetail_mb": [
		"SIiW",
		30
	],
	"./specialtyinstruction/projectdetail_mb.vue": [
		"SIiW",
		30
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "GDQS";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/mobile lazy ^\.\/.*$
// module id = GDQS
// module chunks = 52